import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";

import cheb_img from "../../../assets/images/cheb.jpg";
import { resolveFileUrl } from "constants/config";

const DEFAULT_USERS = [
    {
        id: "id-1",
        "name": "Софья Зубкова",
        isVip: true,
        avatar: "https://images.unsplash.com/photo-1505840717430-882ce147ef2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Путешественник и амбассадор проекта Студтуризм. Люблю исследовать уютные кафе и культурные места."
    },
    {
        id: "id-2",
        "name": "Арина Грозная",
        isVip: true,
        avatar: "https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Амбассадор проекта Студтуризм, влюблённая в природу и горные пейзажи. Фотографирую красоту вокруг."
    },
    {
        id: "id-3",
        "name": "Глеб Широков",
        isVip: true,
        avatar: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Студент и путешественник, делящийся впечатлениями о городах и культурных событиях на пути."
    },
    {
        "name": "Вероника Лукьянова",
        avatar: "https://images.unsplash.com/photo-1507101105822-7472b28e22ac?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Амбассадор Студтуризма, заядлая путешественница. Очарована старинной архитектурой и узкими улочками."
    },
    {
        "name": "Марина Шевцова",
        avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Студентка-путешественница, исследую новые места и вкусы. С любовью рассказываю о кулинарных открытиях."
    },
    {
        "name": "Руслана Данилова",
        avatar: "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Амбассадор проекта Студтуризм, обожаю общаться с местными жителями и узнавать их истории."
    },
    {
        "name": "Никита Лазарев",
        avatar: "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Путешественник и амбассадор Студтуризма, увлечённый историей и местными обычаями."
    },
    {
        "name": "Даниил Мельников",
        avatar: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
        description: "Студент-путешественник, всегда готов найти необычные маршруты и неожиданные приключения."
    },
    {
        "name": "Илья Березин",
        avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Путешественник и амбассадор проекта Студтуризм. Отдаю предпочтение пеших и велосипедных экскурсиях."
    },
    {
        "name": "Антонина Сухова",
        avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Амбассадор Студтуризма, увлечённая фотографией и архитектурой. Делюсь впечатлениями через объектив камеры."
    },
    {
        "name": "Фёдор Анисимов",
        avatar: "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Путешественник и амбассадор Студтуризма, увлечённый архитектурой и гастрономией."
    },
    {
        "name": "Людмила Горбачёва",
        avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: "Студентка-путешественница, ищущая вдохновение в искусстве и культурных событиях."
    },
    {
        "name": "Ярослава Фомичёва",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        description: "Амбассадор Студтуризма, обожающая исторические места и рассказывающая о них со страстью."
    },
    {
        "name": "Арсений Панов",
        avatar: "https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
        description: " Студент-путешественник, разделяющий впечатления о необычных маршрутах и местах."
    },
    {
        "name": "Милана Тихомирова",
        avatar: "https://images.unsplash.com/photo-1509967419530-da38b4704bc6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2395&q=80",
        description: "Студентка-путешественница, искатель приключений и необычных мест."
    },
    {
        "name": "Евгений Кожевников",
        avatar: "https://images.unsplash.com/photo-1593529467220-9d721ceb9a78?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1330&q=80",
        description: "Путешественник и амбассадор Студтуризма, стремлюсь познакомиться с разными культурами."
    },
    {
        "name": "Юлиана Родионова",
        avatar: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1364&q=80",
        description: "Амбассадор проекта Студтуризм, с удовольствием открывающая новые культуры и традиции."
    },
    {
        "name": "Рустам Крюков",
        avatar: "https://images.unsplash.com/photo-1544348817-5f2cf14b88c8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
        description: "Студент-путешественник, увлекающийся археологическими находками и историческими памятниками."
    },
    {
        "name": "Изольда Лаврова",
        avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3688&q=80",
        description: " Амбассадор Студтуризма, влюблённая в местные ремесла и рукоделия."
    },
    {
        "name": "Вадим Белозёров",
        avatar: "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=999&q=80",
        description: "Амбассадор проекта Студтуризм, интересующийся национальными традициями и религиозными обычаями."
    },
    {
        "name": "Эльвира Носкова",
        avatar: "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=989&q=80",
        description: "Студентка-путешественница, наслаждающаяся уединением в природных уголках."
    },
    {
        "name": "Лев Григорьев",
        avatar: "https://images.unsplash.com/photo-1587397845856-e6cf49176c70?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
        description: "Путешественник и амбассадор Студтуризма, стремлюсь понять душу каждой культуры, в которой побываю."
    },
    {
        "name": "Мирослава Филатова",
        avatar: "https://images.unsplash.com/photo-1618835962148-cf177563c6c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1365&q=80",
        description: "Путешественница и амбассадор Студтуризма, исследующая города в поисках интересных историй"
    },
    {
        "name": "Дорофей Терентьев",
        avatar: "https://images.unsplash.com/photo-1509460913899-515f1df34fea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
        description: "Студент-путешественник, обожающий экскурсии и увлекающийся кулинарными экспериментами."
    },
    {
        "name": "Яна Лазуткина",
        avatar: "https://images.unsplash.com/photo-1549351512-c5e12b11e283?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1364&q=80",
        description: "Путешественница и амбассадор Студтуризма, вдохновляющаяся архитектурой и искусством."
    },
    {
        "name": "Рамиль Павличенко",
        avatar: "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
        description: "Путешественник и амбассадор Студтуризма, увлечённый активными отдыхом и приключениями."
    },
    {
        "name": "Инга Зимина",
        avatar: "https://images.unsplash.com/photo-1611594547712-9e5d7da58684?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=986&q=80",
        description: "Амбассадор Студтуризма, страстно рассказывающая о местных легендах и мифах."
    },
    {
        "name": "Герасим Быков",
        avatar: "https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2370&q=80",
        description: "Студент-путешественник, увлекающийся археологическими находками и историческими памятниками."
    },
    {
        "name": "Зоя Турова",
        avatar: "https://images.unsplash.com/photo-1578489758854-f134a358f08b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2370&q=80",
        description: "Студентка-путешественница, находящая вдохновение в местных историях и традициях."
    },
    {
        "name": "Леван Власов",
        avatar: "https://images.unsplash.com/photo-1611695434398-4f4b330623e6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1335&q=80",
        description: "Амбассадор проекта Студтуризм, увлечённый культурными событиями и искусством."
    }
];

export const getName = u => {
    if (u == undefined) {
        return "";
    }
    // Приоритет у поля name
    if (u.name) {
        return u.name;
    }
    if (u.firstName != undefined) {
        return `${u.firstName || ""} ${u.lastName || ""}`;
    }
    return "";
};

export default function AmbassadorsList(props) {
    const {
        users = DEFAULT_USERS,
        onSelect = x => {

        }
    } = props;

    console.log("AmbassadorsList = ", users);

    return (
        <Wrapper>

            <WrapperInner className={"amb_wrapper"}>
                {users.map((a, i) => {
                    let isExpired = (a.ambassadorExpirationTimestamp != undefined && +a.ambassadorExpirationTimestamp < +new Date());

                    return (
                        <Item key={`${a?.id}_${i}`} className={"amb_item"} onClick={() => {
                            console.log("-->> onSelect: a = ", a);
                            onSelect(a);
                        }}>
                            <ImagePlaceholder>
                                <Image src={resolveFileUrl(a.avatar || cheb_img)} />
                            </ImagePlaceholder>
                            <PersonName>
                                {getName(a)}
                                {/*{a.isVip != true ? null :*/}
                                <span style={{ float: "right" }}>
                                        <BadgeSpan style={{ marginLeft: 4 }}>
                                            {a?.ambassadorType || 'Амбассадор'}
                                        </BadgeSpan>
                                    </span>
                                {/*}*/}
                            </PersonName>
                            <PersonSubName>
                                {a.ambassadorAboutMe || a.description}
                            </PersonSubName>
                            {isExpired == false ? null :
                                <div style={{ padding: "0px", color: "red", fontWeight: 'bold' }}>
                                    срок действия истек
                                </div>
                            }
                        </Item>
                    );
                })}
            </WrapperInner>

            {/*<div style={{ textAlign: "center", padding: 30, opacity: 0.75 }}>*/}
            {/*    <span>*/}
            {/*        загрузить еще*/}
            {/*    </span>*/}
            {/*</div>*/}

        </Wrapper>
    );
}

    const BadgeSpan = styled.span`
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      box-sizing: border-box;
      height: 24px;
      line-height: 24px;
      color: rgb(21, 128, 61);
      background-color: rgb(220, 252, 231);
      border-radius: 1000px;
      font-size: 12px;
      alignment: right;
      //opacity: 0.6;
    `;

    const PersonSubName = styled.div`
      font-size: 16px;
      opacity: 0.8;
      padding-top: 5px;
      font-family: "Noto Sans", sans-serif;
    `;

    const PersonName = styled.div`
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      font-family: "Noto Sans", sans-serif;
    `;

    const Image = styled.img`
      height: 356px;
      width: 100%;
      object-fit: cover;
      border-radius: 1rem;
    `;

    const ImagePlaceholder = styled.div`
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 10px;
    `;

    const Wrapper = styled.div`

    `;

    const WrapperInner = styled.div`
      display: flex;
      flex-wrap: wrap;
      font-family: "Noto Sans", sans-serif;
    `;

    const Item = styled.div`
      box-sizing: border-box;
      padding: 10px;
      width: 33.3333%;
      margin-bottom: 30px;
      cursor: pointer;
    `;